import React from "react";
import HeroSection from "../components/Hero";
import About from "../components/About";
import WhyBest from "../components/WhyBest";
import FeaturesSection from "../components/Features";
import Destination from "../components/Destination";
import Contact from "../components/Contact";


function Home() {
  return (
    <div className="home-content">
      <HeroSection />

      <div id="About_Us">
        <About />
        <WhyBest />
      </div>

      <div id="Features">
        <FeaturesSection />
      </div>

      <div id="Destinations">
        <Destination />
      </div>

      <div id="Contact">
        <Contact />
      </div>
    </div>
  );
}

export default Home;
